"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./util/index");
var prod = true;
var Jump = /** @class */ (function () {
    function Jump(options) {
        var host = options.host, _a = options.history, history = _a === void 0 ? false : _a, _b = options.bridgeQuery, bridgeQuery = _b === void 0 ? {} : _b, pages = options.pages, _c = options.baseUrl, baseUrl = _c === void 0 ? '' : _c, _d = options.stagingBaseUrl, stagingBaseUrl = _d === void 0 ? '' : _d;
        this.host = host;
        this.history = history;
        this.bridgeQuery = bridgeQuery;
        this.pages = pages;
        this.baseUrl = baseUrl;
        this.stagingBaseUrl = stagingBaseUrl;
    }
    /**
     * 设置环境
     * @param isProd 是否为线上环境
     */
    Jump.setProdEnv = function (isProd) {
        prod = isProd;
    };
    /**
     * 判断是否为线上环境
     */
    Jump.isProd = function () {
        return prod;
    };
    /**
     * 跳转到外部链接
     * @param url 地址
     * @param query 参数
     */
    Jump.jumpToExternal = function (_a) {
        var _b = _a.url, url = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'back' : _c, _d = _a.ext, ext = _d === void 0 ? {} : _d;
        (0, index_1.jump)(url, type, ext);
    };
    /**
     * 跳转到指定页面
     * @param pageName 页面名称
     * @param query 页面参数
     * @param type 同bridge.loadNewUrl的type参数
     */
    Jump.prototype.jumpToPages = function (_a) {
        var _b = _a.pageName, pageName = _b === void 0 ? '' : _b, _c = _a.query, query = _c === void 0 ? {} : _c, _d = _a.type, type = _d === void 0 ? 'back' : _d, _e = _a.ext, ext = _e === void 0 ? {} : _e;
        var url = this.getUrl({ pageName: pageName, query: query });
        if (url) {
            (0, index_1.jump)(url, type, ext);
        }
    };
    /**
     * 获取页面地址
     * @param pageName 页面名称
     * @param query 页面参数
     */
    Jump.prototype.getUrl = function (_a) {
        var _b = _a.pageName, pageName = _b === void 0 ? '' : _b, _c = _a.query, query = _c === void 0 ? {} : _c;
        var path = this.pages[pageName];
        if (!path) {
            console.error('请确定pageName已在配置文件中');
            return '';
        }
        var host = this.getHost();
        var param = { host: host, query: query, path: path };
        return this.history ? this.getUrlWithHistoryRouter(param) : this.getUrlWithHashRouter(param);
    };
    /**
     * 获取域名 + 路径前缀
     */
    Jump.prototype.getHost = function () {
        // prt 的baseUrl和staging的baseUrl一致
        if ((0, index_1.isPrt)()) {
            return "".concat(window.location.origin).concat(this.stagingBaseUrl || this.baseUrl);
        }
        // fix staging 域名需要获取当前origin和baseUrl组合到一起
        return Jump.isProd() ? this.host.production : ((0, index_1.isStaging)() ? "".concat(window.location.origin).concat(this.stagingBaseUrl || this.baseUrl) : this.host.beta);
    };
    Jump.prototype.getUrlWithHashRouter = function (_a) {
        var _b = _a.host, host = _b === void 0 ? '' : _b, _c = _a.query, query = _c === void 0 ? {} : _c, _d = _a.path, path = _d === void 0 ? '' : _d;
        var _e = query.bridgeQuery, bridgeQuery = _e === void 0 ? {} : _e, _f = query.pageQuery, pageQuery = _f === void 0 ? {} : _f;
        return "".concat(host).concat((0, index_1.stringify)(__assign(__assign(__assign({}, this.bridgeQuery), bridgeQuery), { __llTimestamp: Date.now() })), "#").concat(path).concat((0, index_1.stringify)(pageQuery, path));
    };
    Jump.prototype.getUrlWithHistoryRouter = function (_a) {
        var _b = _a.host, host = _b === void 0 ? '' : _b, _c = _a.query, query = _c === void 0 ? {} : _c, _d = _a.path, path = _d === void 0 ? '' : _d;
        var _e = query.bridgeQuery, bridgeQuery = _e === void 0 ? {} : _e, _f = query.pageQuery, pageQuery = _f === void 0 ? {} : _f;
        return "".concat(host).concat(path).concat((0, index_1.stringify)(__assign(__assign(__assign(__assign({}, this.bridgeQuery), bridgeQuery), pageQuery), { __llTimestamp: Date.now() }), path));
    };
    return Jump;
}());
exports.default = Jump;
